import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from 'src/environments/environment';
@Injectable({
  providedIn: 'root'
})
export class CouponService {

  constructor(private http: HttpClient) { }
  createCoupon(data:any): Observable<any> {
    return this.http.post(environment.createCoupon,data);
  }

  getAllCouponWithCount(data:any): Observable<any> {
    return this.http.post(environment.getAllCouponWithCount,data);
  }

  getCoupon(data:any): Observable<any> {
    return this.http.post(environment.getCoupon,data);
  }

  updateCoupon(data:any): Observable<any> {
    return this.http.post(environment.updateCoupon,data);
  }

  deleteCoupon(data:any): Observable<any> {
    return this.http.post(environment.deleteCoupon,data);
  }

}
